import axios from "@/common/http";
export default {
  state: () => ({
    communityLoading: false,
  }),
  mutations: {
    setCommunityLoading: (state, value) => {
      state.communityLoading = value;
    },
  },
  actions: {
    /**
     *@desc 邀请列表
     */
    async postInvitefriends({ commit, state }, data) {
      state.communityLoading = true;
      const res = await axios.post("/v1/invitefriends/list", data);
      console.log(commit);
      state.communityLoading = false;
      return res;
    },
    /**
     * 订单列表
     */
    async postOrderList({ commit, state }, data) {
      state.communityLoading = true;
      const res = await axios.post("/v1/invitefriends/order_list", data);
      console.log(commit);
      state.communityLoading = false;
      return res;
    },
  },
  getters: {},
};
